import React from 'react';

const getStyles = (theme) => {
    const isDark = theme === 'dark';
    return {
        spinnerOverlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: isDark ? 'rgba(0, 0, 0, 0.7)' : 'rgba(255, 255, 255, 0.7)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
        },
        spinner: {
            border: `8px solid ${isDark ? '#444' : '#f3f3f3'}`,
            borderTop: `8px solid ${isDark ? '#6cb2f7' : '#3498db'}`,
            borderRadius: '50%',
            width: '60px',
            height: '60px',
            animation: 'spin 1s linear infinite',
        },
        // The @keyframes for spin are added globally in index.css
    };
};

const Spinner = ({ theme = 'light' }) => {
    const styles = getStyles(theme);
    return (
        <div style={styles.spinnerOverlay}>
            <div style={styles.spinner}></div>
        </div>
    );
};

export default Spinner;
